import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import get from "lodash/get";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  AttendancePolicyData,
  CheckActionPermission,
  CommonApiAction,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CreatePolicyImage from "../../../../../Assets/Images/site_stats.svg";
import PageNotFound from "../../../../../Component/NotFound/index";
import Stepper from "../../../../../Component/Stepper";
import { ApiReducerType, ReducersTypes } from "../../../../../Constants";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import Absentieesm from "./Absentieesm";
// Component
import NameDesc from "./NameDesc";
import Preview from "./Preview";
import Punctuality from "./Punctuality";
import TimeAtWork from "./TimeAtWork";
import WorkRequest from "./WorkRequest";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

const policystyle = {
  "text-align": "left",
};

const ActiveHeaders = [
  {
    key: "attendancepolicyname",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Policy Name" />,
    type: TDTypeConsts.EDIT_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  {
    key: "assignedEmployeeList",
    name: (
      <FormattedMessage
        id="LbAssignedEmployee"
        defaultMessage="Assigned Employee"
      />
    ),
    type: TDTypeConsts.ASSIGNED_USER,
    style: { padding: "0" },
  },
  {
    key: "policystatus",
    name: (
      <FormattedMessage id="LbPolicyStatus" defaultMessage="Policy Status" />
    ),
    type: TDTypeConsts.POLICY_STATUS,
    style: policystyle,
  },
  {
    key: "versioncount",
    name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />,
    type: TDTypeConsts.VERSIONS,
  },
];

const DraftHeaders = [
  {
    key: "attendancepolicyname",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Policy Name" />,
    type: TDTypeConsts.EDIT_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  {
    key: "policystatus",
    name: (
      <FormattedMessage id="LbPolicyStatus" defaultMessage="Policy Status" />
    ),
    type: TDTypeConsts.POLICY_STATUS,
  },
];

const VersionsHeaders = [
  {
    key: "attendancepolicyname",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Policy Name" />,
    type: TDTypeConsts.POLICY_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  {
    key: "policystatus",
    name: (
      <FormattedMessage id="LbPolicyStatus" defaultMessage="Policy Status" />
    ),
    type: TDTypeConsts.POLICY_STATUS,
  },
  {
    key: "version",
    name: <FormattedMessage id="LbVersion" defaultMessage="Version" />,
    type: TDTypeConsts.OTHERS,
  },
];

class AttendancePolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      actionidList: "",
      headers: ActiveHeaders,
      value: 0,
      completed: {},
      activeStep: 0,
      parentid: null,
      currentRoute: "list",
      AllStep: [],
      Breadcrums: ["Track", "Attendance", "Policy"],
      editPre: true,
      permissions: { readOnly: false, editable: false },
    };
    this.GetSubscriptionLeaves = this.GetSubscriptionLeaves.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancepolicy,navigation");
    this.props.history.push(`${this.props.match.path}/list`);
    this.GetSubscriptionLeaves();
  }

  componentDidMount() {
    // this.GetSubscriptionLeaves()

    const [isTrue, permissions] = CheckActionPermission("attendancePolicy");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.handleChange(null, 0);
        if (
          this.props.history.location.pathname.includes("versions") ||
          this.props.history.location.pathname.includes("view")
        ) {
          this.props.history.push(`${this.props.match.path}/list`);
          this.setState({ currentRoute: "list", parentid: null }, () => {
            // this.props.GetAllAttendancePolicy('attendance/allattendancepolicybysubid/1')
            this.props.CommonApiAction(
              ApiReducerType.ATTENDANCE_POLICY,
              "get",
              "attendance/allattendancepolicybysubid/1",
              {},
            );
          });
        } else if (this.props.history.location.pathname.includes("list")) {
          this.props.CommonApiAction(
            ApiReducerType.ATTENDANCE_POLICY,
            "get",
            "attendance/allattendancepolicybysubid/1",
            {},
          );
        } else {
          // Do nothing on create
          this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY);
          this.GetSubscriptionLeaves();
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  GetSubscriptionLeaves() {
    instance
      .get("leaves/allleavebysubid/3")
      .then((result) => {
        const AllStep = [
          {
            step: 1,
            component: (
              <NameDesc
                onRef={(ref) =>
                  this.setState({
                    child0: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
              />
            ),
            label: (
              <FormattedMessage id="LbDescribe" defaultMessage="Describe" />
            ),
            isError: false,
          },
          {
            step: 2,
            component: (
              <WorkRequest
                onRef={(ref) =>
                  this.setState({
                    child1: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                      onPrev: this.onPrevClick,
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
              />
            ),
            label: "Work Request",
            isError: false,
          },
          {
            step: 3,
            component: (
              <Absentieesm
                onRef={(ref) =>
                  this.setState({
                    child2: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                      onPrev: this.onPrevClick,
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
                LeaveType={result.data.result}
              />
            ),
            label: "Absenteeism",
            isError: false,
          },
          {
            step: 4,
            component: (
              <Punctuality
                onRef={(ref) =>
                  this.setState({
                    child3: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                      onPrev: this.onPrevClick,
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
                LeaveType={result.data.result}
              />
            ),
            label: "Punctuality",
            isError: false,
          },
          {
            step: 5,
            component: (
              <TimeAtWork
                onRef={(ref) =>
                  this.setState({
                    child4: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                      onPrev: this.onPrevClick,
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
                LeaveType={result.data.result}
              />
            ),
            label: "Time At Work",
            isError: false,
          },
          {
            step: 6,
            component: (
              <Preview
                onRef={(ref) =>
                  this.setState({
                    child5: {
                      ...ref,
                      onCancel: this.Cancel,
                      onSaveDraft: this.onSaveDraft,
                      onPrev: this.onPrevClick,
                      onNext: this.Save,
                      nextButtonLabel: "Save",
                    },
                  })
                }
                StepError={this.StepError.bind(this)}
                click={this.onClick}
                LeaveType={result.data.result}
              />
            ),
            label: "Preview",
            isError: false,
          },
        ];

        this.setState({ AllStep, LeaveType: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setHelperText = (key) => {
    this.props.setHelperText({ helperText: key });
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  componentWillUnmount() {
    this.props.CommonReducerAction(
      `${ApiReducerType.ATTENDANCE_POLICY}_PENDING`,
    );
    this.props.CommonReducerAction(`${ReducersTypes.LANGUAGE}_PENDING`);
    this.setHelperText("");
  }

  componentWillReceiveProps(props) {
    if (!props.history.location.pathname.includes(this.state.currentRoute)) {
      if (props.history.location.pathname.includes("list")) {
        // this.setState({headers:ActiveHeaders})
        this.setState({
          currentRoute: "list",
          headers: ActiveHeaders,
          parentid: null,
        });
        this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY);
        this.state.Breadcrums.splice(3);
        // if(Breadcrums.length > 3){
        // Breadcrums.splice(3)
        // this.setState({Breadcrums})
        // }z
        // this.state.headers[0].type = TDTypeConsts.EDIT_NAME
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        // this.props.GetAllAttendancePolicy('attendance/allattendancepolicybysubid/' + status)
        this.props.CommonApiAction(
          ApiReducerType.ATTENDANCE_POLICY,
          "get",
          `attendance/allattendancepolicybysubid/${status}`,
          {},
        );
        // if (this.state.parentid) {
        // let index = this.state.headers.findIndex(x => x.key == 'versioncount')
        // this.state.headers.splice(index, 1)
        // index = this.state.headers.findIndex(x => x.key == 'policystatus')
        // this.state.headers.splice(index, 1)
        // this.state.headers.push({ key: 'assignedEmployeeList', name: <FormattedMessage id="LbAssignedUser" defaultMessage="Assigned User" />, type: TDTypeConsts.ASSIGNED_USER, style: { padding: '0' } },
        // { key: 'policystatus', name: <FormattedMessage id="LbPolicyStatus" defaultMessage="Policy Status" />, type: TDTypeConsts.POLICY_STATUS },
        // { key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />, type: TDTypeConsts.VERSIONS })
        // this.setState({ parentid: null })
        // }
      } else if (props.history.location.pathname.includes("versions")) {
        this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY);
        // this.state.Breadcrums.splice(3,1,"Versions")
        if (this.props.InitAttendancePolicy.attendancepolicyname) {
          this.state.Breadcrums.splice(
            3,
            1,
            this.props.InitAttendancePolicy.attendancepolicyname,
          );
        }
        this.setState(
          {
            Breadcrums: this.state.Breadcrums,
            currentRoute: "versions",
            headers: VersionsHeaders,
          },
          () => {
            if (!this.state.parentid) {
              this.props.history.push(`${this.props.match.path}/list`);
            } else {
              this.onVersionChange(this.state.parentid);
            }
            // let verObject = { key: 'version', name: <FormattedMessage id="LbVersion" defaultMessage="Version" />, type: TDTypeConsts.OTHERS }
            // let index = this.state.headers.findIndex(x => x.key == 'versioncount')
            // this.state.headers.splice(index, 1)
            // let indexlist = this.state.headers.findIndex(x => x.key == 'assignedEmployeeList')
            // this.state.headers.splice(indexlist, 1)
            // this.state.headers.push(verObject)
            // this.state.headers[0].type = TDTypeConsts.POLICY_NAME
            // this.props.GetAllAttendancePolicy('attendance/attendancepolicyversion/' + this.state.parentid)
            this.props.CommonApiAction(
              ApiReducerType.ATTENDANCE_POLICY,
              "get",
              `attendance/attendancepolicyversion/${this.state.parentid}`,
              {},
            );
          },
        );
        // }else if(props.history.location.pathname.includes('create')){
        //     if(this.state.currentRoute != "create"){
        //         this.setState({ currentRoute: "create" })
        //     }
      } else if (props.history.location.pathname.includes("view")) {
        this.setState({ currentRoute: "view" });
        // this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY)
      } else if (props.history.location.pathname.includes("create")) {
        this.setState({ currentRoute: "create" });
      } else {
        this.props.history.push(`${this.props.match.path}/list`);
      }
    }
    if (
      props.history.location.pathname.includes("create") &&
      (this.props.InitAttendancePolicy.attendancepolicyname ||
        this.props.InitAttendancePolicy.attendancepolicyname != "")
    ) {
      if (this.props.InitAttendancePolicy.attendancepolicyname) {
        this.state.Breadcrums.splice(
          3,
          1,
          this.props.InitAttendancePolicy.attendancepolicyname,
        );
        this.setState({
          currentRoute: "create",
          Breadcrums: this.state.Breadcrums,
        });
      }
    } else if (
      props.history.location.pathname.includes("view") &&
      (this.props.InitAttendancePolicy.attendancepolicyname ||
        this.props.InitAttendancePolicy.attendancepolicyname != "")
    ) {
      if (this.props.InitAttendancePolicy.attendancepolicyname) {
        this.state.Breadcrums.splice(
          3,
          1,
          this.props.InitAttendancePolicy.attendancepolicyname,
        );
        this.setState({ Breadcrums: this.state.Breadcrums });
      }
    } else if (
      props.history.location.pathname.includes("versions") &&
      (this.props.InitAttendancePolicy.attendancepolicyname ||
        this.props.InitAttendancePolicy.attendancepolicyname != "")
    ) {
      if (this.props.InitAttendancePolicy.attendancepolicyname) {
        this.state.Breadcrums.splice(
          3,
          1,
          this.props.InitAttendancePolicy.attendancepolicyname,
        );
        this.setState({
          currentRoute: "versions",
          Breadcrums: this.state.Breadcrums,
        });
      }
    }
  }

  handleChange = (event, value) => {
    if (this.state.value == value) return false;

    let status;
    value == 0 ? (status = 1) : value == 1 ? (status = 2) : (status = 0);
    this.setState({ value }, () => {
      switch (this.state.value) {
        case 0: {
          this.setState({ headers: ActiveHeaders });
          // let index = this.state.headers.findIndex(x => x.key == 'version')
          // this.state.headers.splice(index, 1)
          // this.state.headers.splice(2,0,{ key: 'assignedEmployeeList', name: <FormattedMessage id="LbAssignedUser" defaultMessage="Assigned User" />, type: TDTypeConsts.ASSIGNED_USER, style: { padding: '0' } })
          // this.state.headers.push({ key: 'policystatus', name: <FormattedMessage id="LbPolicyStatus" defaultMessage="Policy Status" />, type: TDTypeConsts.POLICY_STATUS },
          // { key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />, type: TDTypeConsts.VERSIONS })
          break;
        }
        case 1: {
          this.setState({ headers: DraftHeaders });
          // this.state.headers.splice(this.state.headers.findIndex(x=>x.key == 'versioncount'),1)
          // this.state.headers.splice(this.state.headers.findIndex(x=>x.key == 'assignedEmployeeList'),1)
          break;
        }
        default:
          break;
      }
      // this.props.GetAllAttendancePolicy('attendance/allattendancepolicybysubid/' + status)
      this.props.CommonApiAction(
        ApiReducerType.ATTENDANCE_POLICY,
        "get",
        `attendance/allattendancepolicybysubid/${status}`,
        {},
      );
    });
  };

  _onCreate = () => {
    const { match } = this.props;
    this.props.history.push(`${match.path}/create`);
    this.setState({ completed: {} });
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <span>
            <FormattedMessage
              id="attendancePolicyConcept"
              defaultMessage="The Attendance Policy feature provides you with extensive functionality to define rules that govern how an employee's attendance will be regulated. You can specify what should be done, in case an employee is late, or if she doesn't complete the required hours at work, or is absent without applying for a leave, and much more."
            />
          </span>
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  _renderCreate = () => (
    <CreateComp
      text={this.getText()}
      heading={this.state.value == 0 ? "Concept of Policy" : "No drafts saved"}
      onCreate={this._onCreate}
      imageSrc={this.state.value == 0 ? CreatePolicyImage : emptylist}
      permissions={this.state.permissions}
    />
  );

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  onVersionChange = (parentid) => {
    const { match } = this.props;
    this.setState({ parentid }, () => {
      this.props.history.push(`${match.path}/versions`);
      // this.props.InitAttendancePolicy.attendancepolicyname='Rohit';
      // this.props.GetAllAttendancePolicy('attendance/attendancepolicyversions/' + this.state.parentid)
      // this.props.CommonApiAction(ApiReducerType.ATTENDANCE_POLICY,'get','attendance/allattendancepolicybysubid'+status,{})
      this.props.CommonApiAction(
        ApiReducerType.ATTENDANCE_POLICY,
        "get",
        `attendance/attendancepolicyversions/${this.state.parentid}`,
        {},
      );
    });
  };

  onEdit(row, editPre) {
    this.setState({ editPre });
    instance
      .get(`/attendance/attendancepolicy/${row.attendancepolicyid}`)
      .then((result) => {
        this.checkCompleted(result.data.result);
        this.props.AttendancePolicyData({
          ...this.props.InitAttendancePolicy,
          ...result.data.result,
        });
        this.props.history.push(`${this.props.match.path}/view`);
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  checkCompleted = (data) => {
    const completed = {};

    if (data.attendancepolicyname) Object.assign(completed, { 0: true });
    else Object.assign(completed, { 0: false });

    // if(typeof data.iswfo == "boolean" || data.iswfh == "boolean" || data.isoutduty== "boolean")
    Object.assign(completed, { 1: true });
    // else
    //     Object.assign(completed ,{ 1:false})

    if (typeof data.isabsenteeismrule == "boolean") {
      Object.assign(completed, { 2: true });
    } else Object.assign(completed, { 2: false });

    if (typeof data.ispunctualityrule == "boolean") {
      Object.assign(completed, { 3: true });
    } else Object.assign(completed, { 3: false });

    if (typeof data.istimeatworkrule == "boolean") {
      Object.assign(completed, { 4: true });
    } else Object.assign(completed, { 4: false });

    // eslint-disable-next-line array-callback-return
    Object.keys(completed).map((step) => {
      if (!step) {
        Object.assign(completed, { 5: false });
      } else {
        Object.assign(completed, { 5: true });
      }
    });
    this.setState({ completed });
  };

  _renderList = () => {
    const { ATTENDANCE_POLICY } = this.props;
    return (
      <List
        list={ATTENDANCE_POLICY.Data}
        headers={this.state.headers}
        headerIndex={0}
        onCreate={this._onCreate}
        onVersionChange={this.onVersionChange}
        onEdit={this.onEdit.bind(this)}
        // onDelete={this.onDelete}
        module={"Attendence policie"}
        goTo={this.props.goTo}
        sortOrder="desc"
        permissions={this.state.permissions}
      />
    );
  };

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          {/* <Tabs value={this.state.value} onChange={this.handleChange.bind(this)} indicatorColor="primary" textColor="primary" scrollButtons="auto" className="master-sh" >
                            <Tab label={<FormattedMessage id="LbActive" defaultMessage="Active" />} className="tabheading" />
                            <Tab label={<FormattedMessage id="LbDraft" defaultMessage="Draft" />} className="tabheading" />
                        </Tabs> */}
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { ATTENDANCE_POLICY } = this.props;
    return (
      <div>
        {ATTENDANCE_POLICY.Data.length == 0 && !ATTENDANCE_POLICY.IsPending ? (
          <div className="margin-top-20">{this._renderCreate()}</div>
        ) : (
          this._renderTab()
        )}
      </div>
    );
  };

  onClick = () => {
    this.child.handleNext();
  };

  StepError(step, error) {
    const indextemp = this.state.AllStep.findIndex((x) => x.step == step);
    const { AllStep } = this.state;
    AllStep[indextemp].isError = error;
    this.setState({ AllStep });
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  Cancel = () => {
    this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY);
    for (const step of this.state.AllStep) {
      step.isError = false;
    }
    const { Breadcrums } = this.state;
    // if(Breadcrums.length > 3){
    Breadcrums.splice(3);
    // this.setState({Breadcrums})
    // }
    this.setState({ Breadcrums, AllStep: this.state.AllStep }, () => {
      this.props.history.push(`${this.props.match.path}/list`);
    });
  };

  _onDelete = () => {
    const { InitAttendancePolicy } = this.props;
    instance
      .delete(
        `/attendance/attendancepolicy/${InitAttendancePolicy.attendancepolicyid}`,
      )
      .then(() => {
        this.props.enqueueSnackbar("Attendance Policy Deleted Successfully", {
          variant: "success",
        });
        this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
        this.setState({ activeStep: 0, completed: {} });
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        // this.props.GetAllAttendancePolicy('attendance/allattendancepolicybysubid/' + status)
        this.props.CommonApiAction(
          ApiReducerType.ATTENDANCE_POLICY,
          "get",
          `attendance/allattendancepolicybysubid/${status}`,
          {},
        );
        this.handleChange(null, this.state.value);
        // this.handleChange(null, 0)
        this.props.history.push(`${this.props.match.path}/list`);
        // this.props.GetAllAttendancePolicy('attendance/attendancepolicyversions/1')
        // this.props.CommonApiAction(ApiReducerType.ATTENDANCE_POLICY,'get','attendance/attendancepolicyversions/1',{})
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  confirmDelete() {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button color="inherit" size="small" onClick={() => this._onDelete()}>
          Yes
        </Button>,
        <Button color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  onSaveDraft = () => {
    this.Save(true);
  };

  Save = (isdraft = false) => {
    const indextemp = this.state.AllStep.map((item) => item.isError).findIndex(
      (x) => x == true,
    );
    if (indextemp >= 0) {
      this.props.enqueueSnackbar("Please resolve all errors", {
        variant: "error",
      });
      return false;
    }
    const { InitAttendancePolicy } = this.props;
    if (
      !InitAttendancePolicy.attendancepolicyname ||
      InitAttendancePolicy.attendancepolicyname == ""
    ) {
      this.props.enqueueSnackbar("Please add attendance policy name", {
        variant: "error",
      });
      return false;
    }

    if (!isdraft) {
      this.props.CommonReducerAction(ReducersTypes.INITATTENDANCEPOLICY);
      const { Breadcrums } = this.state;
      if (Breadcrums.length > 3) {
        Breadcrums.splice(3);
        this.setState({ Breadcrums });
      }
    }
    InitAttendancePolicy.isdraft = isdraft == true ? true : false;
    instance
      .post("/attendance/insertupdateattpolicy", InitAttendancePolicy)
      .then(() => {
        this.props.enqueueSnackbar("Attendance Policy Saved Successfully", {
          variant: "success",
        });
        // if (!isdraft) {

        this.setState({ activeStep: 0, completed: {} });
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        // this.props.GetAllAttendancePolicy('attendance/allattendancepolicybysubid/' + status)
        this.props.CommonApiAction(
          ApiReducerType.ATTENDANCE_POLICY,
          "get",
          `attendance/allattendancepolicybysubid/${status}`,
          {},
        );
        this.handleChange(null, this.state.value);
        this.props.history.push(`${this.props.match.path}/list`);
        // } else {
        //     this.props.AttendancePolicyData({ ...InitAttendancePolicy, "attendancepolicyid": result.data.result[0].attendancepolicyid })
        // }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  _renderForm = () => {
    const { child0, child1, child2, child3, child4, child5 } = this.state;
    const canSaveAsDraft =
      get(this.props, "InitAttendancePolicy.isdraft", "") === true ||
      !get(this.props, "InitAttendancePolicy.attendancepolicyid", "");
    const stepperchilds = [
      child0,
      child1,
      child2,
      child3,
      child4,
      child5,
    ].filter((x) => x);
    !canSaveAsDraft &&
      [...stepperchilds].map((x) => {
        delete x.onSaveDraft;
        return x;
      });
    return (
      <div>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          setStep={this.setStep.bind(this)}
          completed={this.state.completed}
          childs={[child0, child1, child2, child3, child4, child5]}
        />
        {/* <div className="draftbutton-wrapper">
        <div className="draftclosebutton1" onClick={() => this.Cancel()}>
          <span className="floatleft" style={{ marginLeft: 6 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </span>
          <span className="draftclosebutton-text">Close</span>
        </div>
        {this.state.activeStep == this.state.AllStep.length - 1 ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1" style={{ marginLeft: 8 }}>
                Save{" "}
              </span>
            </span>
          </div>
        ) : // for handling Edit mode
        this.props.InitAttendancePolicy.isdraft ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(true)}
          >
            <span className="draftbutton">
              <Done />
              <span className="draft-option" style={{ marginLeft: 8 }}>
                Save As Draft
              </span>
            </span>
          </div>
        ) : (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save </span>
            </span>
          </div>
        )}
      </div> */}
      </div>
    );
  };

  _renderVersion = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        {this._renderList()}
      </Grid>
    </Grid>
  );

  EditPreview = () => {
    this.props.history.push(`${this.props.match.path}/create`);
  };

  _renderViewComponent = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <Preview onRef={() => {}} />
        {this.state.editPre ? (
          <div>
            <div className="deletebutton-wrapper">
              <div className="deletebutton-innerwrapper">
                {this.state.permissions.editable ? (
                  <span className="deletebutton1">
                    <span className="delete-option">
                      <span
                        style={{ float: "left", margin: "0px 8px 0px 4px" }}
                      >
                        Are you sure?
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this._onDelete()}
                      >
                        <svg
                          className="message-edit cursour-pointer save-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#fff"
                            d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.Cancel()}
                      >
                        <svg
                          className="message-edit cursour-pointer close-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          onClick={() => this.Cancel()}
                        >
                          <path
                            fill="#fff"
                            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                    <svg
                      className="delete-svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z" />
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                    </svg>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.Cancel()}
              >
                <span className="floatleft" style={{ marginLeft: 6 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </span>
                <span className="draftclosebutton-text">Close</span>
              </div>
              {this.state.permissions.editable ? (
                <div
                  className="draftbutton-innerwrapper cursour-pointer"
                  onClick={() => this.EditPreview()}
                >
                  <span className="editbutton">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                    <span className="edit-option" style={{ top: 15 }}>
                      Edit
                    </span>
                  </span>
                  {/* <span><DoneAllIcon /> <span className="draft-option">Save </span></span>  */}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="draftbutton-wrapper">
            <div
              className="draftclosebutton cursour-pointer"
              onClick={() => this.Cancel()}
            >
              <span className="floatleft" style={{ marginLeft: 6 }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </span>
              <span className="draftclosebutton-text">Close</span>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );

  render() {
    const { match } = this.props;
    const language = this.props.Language.attendancepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <Helmet>
            <title>{headersList.Config.AttendancePolicy.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <div>
                {this.props.history.location.pathname ===
                  "/config/track/attendance/policy/list" && (
                  <div className="common-menubar-header">
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}
                      indicatorColor="#fff"
                      textColor="primary"
                      scrollButtons="auto"
                    >
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbActive"
                            defaultMessage="Active"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbDraft"
                            defaultMessage="Draft"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border"></div>
                  </div>
                )}
              </div>

              <main className="content-outer-wrapper-with-tab">
                <Grid item xs={12} md={12} sm={12}>
                  <div className="shiftplanner-forms">
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this._renderForm}
                      />
                      <Route
                        exact
                        path={`${match.path}/versions`}
                        render={this._renderVersion}
                      />
                      <Route
                        exact
                        path={`${match.path}/list`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}/view`}
                        render={this._renderViewComponent}
                      />
                      <Route path="**" component={PageNotFound} />
                    </Switch>
                  </div>
                </Grid>
              </main>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ATTENDANCE_POLICY: state.ATTENDANCE_POLICY,
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      CommonApiAction: (type, method, url, data) =>
        CommonApiAction(type, method, url, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(AttendancePolicy)));
